import React from 'react';
import { Phone, MessageSquare, FileText } from 'lucide-react';
import { Link } from 'react-router-dom';

const MobileBar = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-lg lg:hidden z-50">
      <div className="grid grid-cols-3 gap-1 p-2">
        <a
          href="tel:+4923139085116"
          className="flex flex-col items-center justify-center py-3 px-2 bg-[#16A34A] text-white rounded-lg hover:bg-[#16A34A]/90 transition-colors"
        >
          <Phone className="h-5 w-5 mb-1" />
          <span className="text-xs font-medium">Anrufen</span>
        </a>
        <a
          href="https://wa.me/4923139085116"
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center justify-center py-3 px-2 bg-[#0F172A] text-white rounded-lg hover:bg-[#0F172A]/90 transition-colors"
        >
          <MessageSquare className="h-5 w-5 mb-1" />
          <span className="text-xs font-medium">WhatsApp</span>
        </a>
        <Link
          to="/kontakt"
          className="flex flex-col items-center justify-center py-3 px-2 bg-[#111827] text-white rounded-lg hover:bg-[#111827]/90 transition-colors"
        >
          <FileText className="h-5 w-5 mb-1" />
          <span className="text-xs font-medium">Angebot</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileBar;